import React from "react";
import { policeStatistic } from "pages/Dashboards/AdministrativeDashboard/types";
import "../styles.scss";
import SubTitle from "components/SubTitle";
import { useTranslation } from "react-i18next";
import LinePieChart from "common/components/LinePieChart/LinePieChart";
import CustomAreaChart from "common/components/AreaChart/CustomAreaChart";
import {
  getReportsSentDataForAreaChart,
  getReportsSentDataForPieChart,
  periodStrings,
} from "./utils";

type Props = {
  data: policeStatistic;
  period: string;
};

const ReportsSent = ({ data, period }: Props) => {
  const { t } = useTranslation();
  const reportsSentData = getReportsSentDataForAreaChart(data.sendPerPeriod);

  return (
    <div className="chart-container data-box">
      <div className="dashed-inner-border">
        <div className="title-row">
          <SubTitle className="title">{t("reportsSentToPolice")}</SubTitle>
          <div className="title-data">
            <LinePieChart
              innerRadius={15}
              outerRadius={20}
              data={getReportsSentDataForPieChart(
                data?.totalSendByPeriodPercentage
              )}
              percent={data?.totalSendByPeriodPercentage}
            />
            <div className="column">
              <p className="total">
                {t("totalByPeriod")} {periodStrings[period]}
              </p>
              <p className="amount">{data?.totalSendByPeriod}</p>
            </div>
          </div>
        </div>
        <CustomAreaChart data={reportsSentData} period={period} />
      </div>
    </div>
  );
};
export default ReportsSent;
